import { render, staticRenderFns } from "./MakeDealForm.vue?vue&type=template&id=f452f934&scoped=true"
import script from "./MakeDealForm.vue?vue&type=script&lang=js"
export * from "./MakeDealForm.vue?vue&type=script&lang=js"
import style0 from "./MakeDealForm.vue?vue&type=style&index=0&id=f452f934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f452f934",
  null
  
)

export default component.exports